// Custom TinyMce Implementation using Custom Plugins
/* eslint import/no-webpack-loader-syntax: off */
import contentCss from '!!raw-loader!tinymce/skins/ui/oxide/content.min.css';

import React from 'react';
import { Editor } from "@tinymce/tinymce-react";
import { createPortal } from "react-dom";
import ToggleComponent from "v4/components/utils/ToggleComponent/ToggleComponent";
import useInputRichText from "v4/components/form/Field/components/InputRichText/hooks/useInputRichText";

export default React.forwardRef(function InputRichText({
    fieldName,
    fieldValue,
    inputConstraints,
    isRestricted = false,
    onChange,
    height = 250,
    overrideTinyMceInitConfig = {},
    overrideTinyMceProps = {},
    formMetadata = {},
}, ref) {
    const {
        isShowing,
        popupGed,
        isExpanded,
        setIsExpanded,
        initialValue,
        processedValue,
        handleEditorChange,
        language,
        fullname,
        maxHeight,
        pluginList,
        additionalContentCss,
        toolbarWithPlugins,
        openGedPicker,
    } = useInputRichText({
        fieldName,
        fieldValue,
        isRestricted,
        onChange,
        formMetadata,
    });

    return (
        <div
            className={`input-field-rich-text-editor ${isExpanded ? 'is-expanded' : ''}`}
            data-is-required={!!inputConstraints?.required}
            style={{ '--tinymce-default-height': `${height}px` }}
        >
            <Editor
                textareaName={fieldName}
                initialValue={initialValue}
                onFocus={() => setIsExpanded(true)}
                init={{
                    image_title: true,
                    file_picker_types: 'image',
                    paste_data_images: true,
                    object_resizing: true,
                    file_picker_callback: (callback) => openGedPicker(base64 => callback(base64), ['png', 'bmp', 'jpg', 'jpeg', 'gif'], 'base64'),
                    height: height,
                    max_height: maxHeight,
                    menubar: false,
                    plugins: pluginList,
                    toolbar: toolbarWithPlugins,
                    content_style: contentCss + additionalContentCss,
                    language: language === 'fr' ? 'fr_FR' : undefined,
                    language_url: language === 'fr' ? process.env.REACT_APP_PUBLIC_URL + 'tinymce_lang/' + language + '.js' : undefined,
                    insertdatetime_formats: language === 'fr' ? ['%d/%m/%Y', '%H:%M', `%d/%m/%Y ${fullname}`, `%d/%m/%Y %H:%M ${fullname}`, fullname] : ['%m/%d/%Y', '%H:%M', `%m/%d/%Y ${fullname}`, `%m/%d/%Y %H:%M ${fullname}`, fullname],
                    ...overrideTinyMceInitConfig,
                }}
                value={processedValue}
                onEditorChange={handleEditorChange}
                ref={(editor) => {
                    if (ref) ref.current = editor;

                    if (editor) editor.elementRef.current.TinyMCE = editor;
                }}
                data-name={fieldName}
                {...overrideTinyMceProps}
            />

            {popupGed && createPortal(
                <ToggleComponent isShowing={isShowing} shouldRemoveFromDom={true}>
                    {popupGed}
                </ToggleComponent>,
                document.querySelector('body'))}
        </div>
    )
})
